/**
 * 🆕 [Phase 85 Sprint 1.B — 2026-06-23] Helpers localStorage pour LegendeBadgesCRM.
 *
 * Extrait dans un module séparé sans imports React pour faciliter les tests unitaires
 * Jest (qui ne peuvent pas résoudre `@/components/ui/...` sans craco config jest).
 */

export const LEGENDE_BADGES_CRM_KEY_HIDDEN = 'legende-badges-crm-hidden';
export const LEGENDE_BADGES_CRM_KEY_COLLAPSED = 'legende-badges-crm-collapsed';

/** True si la légende a été masquée définitivement par l'utilisateur. */
export function isLegendeBadgesCRMHidden() {
  try {
    return localStorage.getItem(LEGENDE_BADGES_CRM_KEY_HIDDEN) === '1';
  } catch (_) {
    return false;
  }
}

/** Réouvre la légende (efface le flag hidden et collapsed). Retourne true si OK. */
export function reopenLegendeBadgesCRM() {
  try {
    localStorage.removeItem(LEGENDE_BADGES_CRM_KEY_HIDDEN);
    localStorage.setItem(LEGENDE_BADGES_CRM_KEY_COLLAPSED, '0');
    return true;
  } catch (_) {
    return false;
  }
}

/** Set le flag hidden à "1" (utilisé par le bouton "Ne plus afficher"). */
export function hideLegendeBadgesCRM() {
  try {
    localStorage.setItem(LEGENDE_BADGES_CRM_KEY_HIDDEN, '1');
    return true;
  } catch (_) {
    return false;
  }
}

/** True si la légende est collapsée. */
export function isLegendeBadgesCRMCollapsed() {
  try {
    return localStorage.getItem(LEGENDE_BADGES_CRM_KEY_COLLAPSED) === '1';
  } catch (_) {
    return false;
  }
}

/** Set l'état collapsed/expanded dans localStorage. */
export function setLegendeBadgesCRMCollapsed(collapsed) {
  try {
    localStorage.setItem(LEGENDE_BADGES_CRM_KEY_COLLAPSED, collapsed ? '1' : '0');
    return true;
  } catch (_) {
    return false;
  }
}
